import { forwardRef } from 'react';
import PropTypes from 'prop-types';

import ArrowLeft from '../../../assets/icons/arrow-left.svg';
import Bag from '../../../assets/icons/bag.svg';
import Blend from '../../../assets/icons/blend.svg';
import Calculator from '../../../assets/icons/calculator.svg';
import Calendar from '../../../assets/icons/calendar.svg';
import Certificate from '../../../assets/icons/certificate.svg';
import ChangeArrow from '../../../assets/icons/change-arrow.svg';
import Check from '../../../assets/icons/check.svg';
import CheckMark from '../../../assets/icons/checkmark.svg';
import ChevronDown from '../../../assets/icons/chevron-down.svg';
import ChevronDownTiaaBlue from '../../../assets/icons/chevron-down-tiaa-blue.svg';
import ChevronLeft from '../../../assets/icons/chevron-left.svg';
import ChevronRight from '../../../assets/icons/chevron-right.svg';
import ChevronThick from '../../../assets/icons/chevron-thick.svg';
import ChevronUp from '../../../assets/icons/chevron-up.svg';
import ChevronUpTiaaBlue from '../../../assets/icons/chevron-up-tiaa-blue.svg';
import Coins from '../../../assets/icons/coins.svg';
import Disclosures from '../../../assets/icons/disclosures.svg';
import Document from '../../../assets/icons/document.svg';
import Down from '../../../assets/icons/down.svg';
import DynamicGreetingCheck from '../../../assets/icons/dynamic-greeting-check.svg';
import DynamicGreetingX from '../../../assets/icons/dynamic-greeting-x.svg';
import Equities from '../../../assets/icons/equities.svg';
import FixedAnnuity from '../../../assets/icons/fixed-annuity.svg';
import FixedIncome from '../../../assets/icons/fixed-income.svg';
import Glossary from '../../../assets/icons/glossary.svg';
import Growth from '../../../assets/icons/coins.svg';
import Hand from '../../../assets/icons/hand.svg';
import HighCredit from '../../../assets/icons/high-credit.svg';
import House from '../../../assets/icons/house.svg';
import Income from '../../../assets/icons/income.svg';
import Index from '../../../assets/icons/index.svg';
import Info from '../../../assets/icons/info.svg';
import InvestedCheck from '../../../assets/icons/invested-check.svg';
import Kebab from '../../../assets/icons/kebab.svg';
import Large from '../../../assets/icons/large.svg';
import Learn from '../../../assets/icons/learn.svg';
import Link from '../../../assets/icons/link.svg';
import LongDuration from '../../../assets/icons/long-duration.svg';
import LowCredit from '../../../assets/icons/low-credit.svg';
import LowExpense from '../../../assets/icons/low-expense.svg';
import Market from '../../../assets/icons/market.svg';
import MediumCredit from '../../../assets/icons/medium-credit.svg';
import MediumDuration from '../../../assets/icons/medium-duration.svg';
import Mid from '../../../assets/icons/mid.svg';
import Money from '../../../assets/icons/money.svg';
import Mutual from '../../../assets/icons/mutual.svg';
import Perform from '../../../assets/icons/perform.svg';
import PieFull from '../../../assets/icons/pie-full.svg';
import PieHalf from '../../../assets/icons/pie-half.svg';
import Pig from '../../../assets/icons/pig.svg';
import Planning from '../../../assets/icons/planning.svg';
import Printer from '../../../assets/icons/printer.svg';
import PrinterBlue from '../../../assets/icons/printer-blue.svg';
import Product from '../../../assets/icons/product.svg';
import QuestionMarkCircled from '../../../assets/icons/question-mark-circled.svg';
import QuestionMarkCircledSolid from '../../../assets/icons/question-mark-circled-solid.svg';
import Research from '../../../assets/icons/research.svg';
import RetirePlus from '../../../assets/icons/retireplus.svg';
import SavePDF from '../../../assets/icons/save-pdf.svg';
import ShortDuration from '../../../assets/icons/short-duration.svg';
import Small from '../../../assets/icons/small.svg';
import Star from '../../../assets/icons/star.svg';
import StarOutline from '../../../assets/icons/star-outline.svg';
import TIAALogo from '../../../assets/icons/TIAA_logo.svg';
import Tag from '../../../assets/icons/tag.svg';
import TagGlossary from '../../../assets/icons/tag-glossary.svg';
import TargetDate from '../../../assets/icons/target-date.svg';
import Times from '../../../assets/icons/times.svg';
import Up from '../../../assets/icons/up.svg';
import Value from '../../../assets/icons/value.svg';
import Video from '../../../assets/icons/video.svg';
import Warehouse from '../../../assets/icons/warehouse.svg';
import disclosureScreener from '../../../assets/icons/disclosure-screener.svg';
import disclosureScreenerBlue from '../../../assets/icons/disclosure-screener-blue.svg';
import documentScreener from '../../../assets/icons/document-screener.svg';
import restriction from '../../../assets/icons/restriction.svg';

import styles from './icon.module.scss';
import { augmentClassName } from '../../../utils/GlobalCssProxy';

const className = augmentClassName(styles);

export const variants = {
  ArrowLeft,
  Bag,
  Blend,
  Calculator,
  Calendar,
  Certificate,
  ChangeArrow,
  Check,
  CheckMark,
  ChevronDown,
  ChevronDownTiaaBlue,
  ChevronLeft,
  ChevronRight,
  ChevronThick,
  ChevronUp,
  ChevronUpTiaaBlue,
  Coins,
  Disclosures,
  Document,
  Down,
  DynamicGreetingCheck,
  DynamicGreetingX,
  Equities,
  FixedAnnuity,
  FixedIncome,
  Glossary,
  Growth,
  Hand,
  HighCredit,
  House,
  Income,
  Index,
  Info,
  InvestedCheck,
  Kebab,
  Large,
  Learn,
  Link,
  LongDuration,
  LowCredit,
  LowExpense,
  Market,
  MediumCredit,
  MediumDuration,
  Mid,
  Money,
  Mutual,
  Perform,
  PieFull,
  PieHalf,
  Pig,
  Planning,
  Printer,
  PrinterBlue,
  Product,
  QuestionMarkCircled,
  QuestionMarkCircledSolid,
  Research,
  RetirePlus,
  SavePDF,
  ShortDuration,
  Small,
  Star,
  StarOutline,
  TIAALogo,
  Tag,
  TagGlossary,
  TargetDate,
  Times,
  Up,
  Value,
  Video,
  Warehouse,
  disclosureScreener,
  disclosureScreenerBlue,
  documentScreener,
  restriction
};

const iconClass = forPrint =>
  className.string('svg-icon', 'position-relative', !forPrint && 'd-inline-block');

const Icon = forwardRef(
  ({ variant, className: classNameProp, forPrint = false, customClassOnly, ...props }, ref) => {
    let classes = '';
    if (customClassOnly) {
      classes = classNameProp;
    } else {
      classes = classNameProp ? `${iconClass(forPrint)} ${classNameProp}` : iconClass(forPrint);
    }

    const Component = variants[variant]; // NOSONAR

    if (props.onClick) {
      return (
        <button {...props} ref={ref} {...className('button-icon-wrapper', 'btn-reset')}>
          <Component className={classes} />
        </button>
      );
    }
    return <Component className={classes} {...props} ref={ref} />;
  }
);
Icon.displayName = 'Icon';

Icon.propTypes = {
  className: PropTypes.string,
  customClassOnly: PropTypes.bool,
  forPrint: PropTypes.bool,
  onClick: PropTypes.func,
  variant: PropTypes.oneOf(Object.keys(variants)).isRequired
};

// Expose variants as sub-components
Object.keys(variants).forEach(v => {
  /* eslint-disable react/display-name */
  const iconSub = forwardRef((props, ref) => {
    if (props.onClick) {
      return (
        <button {...props} ref={ref} {...className('button-icon-wrapper')}>
          <Icon className={props.className} variant={v} />
        </button>
      );
    }
    return <Icon {...props} variant={v} ref={ref} />;
  });
  /* eslint-enable react/display-name */
  iconSub.propTypes = {
    onClick: PropTypes.func,
    className: PropTypes.string
  };
  Icon[v] = iconSub;
});

export default Icon;
